// extracted by mini-css-extract-plugin
module.exports = {"bgHome":"Home_bgHome__1b3gK"};